'use client';

import { c as _c } from "react/compiler-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import type { VideoModalTypes } from '@/app/about/_types/modalTypes';
import { useDeviceStore } from '@/store/about/deviceStore';
export default function VideoModal(t0) {
  const $ = _c(17);
  const {
    isOpen,
    close,
    src
  } = t0;
  const {
    deviceType
  } = useDeviceStore();
  const t1 = deviceType === "mobile" ? "is_mobile" : "is_desktop";
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Dialog.Title />;
    t3 = <Dialog.Description />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== src) {
    t4 = <video preload="auto" autoPlay={true} muted={true} controls={true}><source src={src} type="video/mp4" /></video>;
    $[2] = src;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text_blind">닫기</span>;
    t6 = <i className="icon_close" />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== close) {
    t7 = <Dialog.Close asChild={true}><button className="btn_close" type="button" onClick={close}>{t5}{t6}</button></Dialog.Close>;
    $[6] = close;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t4 || $[9] !== t7) {
    t8 = <Dialog.Content className="modal modal_full_video">{t2}{t3}{t4}{t7}</Dialog.Content>;
    $[8] = t4;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t1 || $[12] !== t8) {
    t9 = <Dialog.Portal><div className={t1}>{t8}</div></Dialog.Portal>;
    $[11] = t1;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isOpen || $[15] !== t9) {
    t10 = <Dialog.Root open={isOpen}>{t9}</Dialog.Root>;
    $[14] = isOpen;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}